module.exports = __webpack_public_path__ + "img/google_play_icon.7bd4821c.png";